import { Pipe, PipeTransform } from "@angular/core";
import { AccionesItemDTO } from "@DTOS";
import { TipoAccionesEnum } from "@shared/enums";

@Pipe({
    name: "objetivoAccion"
})
export class ObjetivoAccionPipe implements PipeTransform {

    transform(accion: AccionesItemDTO): string {
        switch (accion.type) {
        case TipoAccionesEnum.ADD_TAG_TO_USER:
        case TipoAccionesEnum.REMOVE_TAG_FROM_USER:
            return `Etiqueta #${accion.payload.tagId}`;
        case TipoAccionesEnum.ADD_USER_TO_CAMPAIGN:
        case TipoAccionesEnum.REMOVE_USER_FROM_CAMPAIGN:
            return `Grupo #${accion.payload.grupoId}`;
        case TipoAccionesEnum.ADD_USER_TO_CHALLENGE:
        case TipoAccionesEnum.REMOVE_USER_FROM_CHALLENGE:
            return `Desafio #${accion.payload.tagId}`;
        }
    }

}
